export const dlCartRemoveEvent = (items) => {
    window.dataLayer.push({
        event: 'removeFromCart',
        cart: {
            removed_products: items.map(({ item }) => item)
        }
    });
};
